import React, { useEffect, useState } from 'react';
import { Box, Typography, Button, Checkbox, FormControlLabel, CircularProgress, Alert } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { fetchNeuroConsent, startNeuroEvaluation } from '../../store/slices/neuroSlice';
import { flowLogger } from '../../utils/flowLogger';

const NeuroConsentStep = ({ kid, onAccepted, onBack }) => {
  const dispatch = useDispatch();
  const { consent, loading, error } = useSelector((state) => state.neuro);
  const [checked, setChecked] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    dispatch(fetchNeuroConsent());
  }, [dispatch]);

  const handleAccept = async () => {
    if (!checked || !consent || !kid) return;
    setSubmitting(true);
    try {
      const result = await dispatch(startNeuroEvaluation({
        kid_id: kid.id,
        consent_version_id: consent.id,
      })).unwrap();
      flowLogger('neuro.consent.accepted', { kidId: kid.id, evaluationId: result.id });
      onAccepted(result);
    } catch (e) {
      console.error(e);
    } finally {
      setSubmitting(false);
    }
  };

  if (loading && !consent) {
    return (
      <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: '#FFF9F0' }}>
        <CircularProgress sx={{ color: '#784e3c' }} />
      </Box>
    );
  }

  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#FFF9F0', px: 2, py: 4, maxWidth: 520, mx: 'auto' }}>
      <Typography variant="h5" sx={{ color: '#784e3c', fontWeight: 700, mb: 2 }}>
        {consent?.title || 'Consentement'}
      </Typography>
      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      <Typography sx={{ color: '#444', mb: 3, whiteSpace: 'pre-wrap', lineHeight: 1.6 }}>
        {consent?.body}
      </Typography>
      {consent?.disclaimer && (
        <Typography variant="caption" sx={{ color: '#888', display: 'block', mb: 3 }}>
          {consent.disclaimer}
        </Typography>
      )}
      <FormControlLabel
        control={
          <Checkbox
            checked={checked}
            onChange={(e) => setChecked(e.target.checked)}
            sx={{ '&.Mui-checked': { color: '#784e3c' } }}
          />
        }
        label="J'accepte et je comprends que cet outil n'est pas un diagnostic médical"
        sx={{ mb: 3, alignItems: 'flex-start' }}
      />
      <Box sx={{ display: 'flex', gap: 2, flexDirection: 'column' }}>
        <Button
          variant="contained"
          disabled={!checked || submitting}
          onClick={handleAccept}
          sx={{ minHeight: 48, backgroundColor: '#784e3c', touchAction: 'manipulation' }}
        >
          {submitting ? 'Chargement...' : 'Commencer le questionnaire'}
        </Button>
        <Button type="button" onClick={onBack} sx={{ minHeight: 48, color: '#784e3c' }}>
          Retour
        </Button>
      </Box>
    </Box>
  );
};

export default NeuroConsentStep;
